/**
 * Type: コンポーネント
 * What: ページネーション
 */
/* import React from 'react';
import { Link } from 'gatsby';

const Pagination = ({ pageContext, pathPrefix }) => {
  const { previousPagePath, nextPagePath } = pageContext;

  return (
    <div className="container">
      <div className="columns">
        <div className="column">
          <nav className="pagination" role="navigation" aria-label="pagination">
            {previousPagePath && (
              <Link
                to={previousPagePath}
                rel="prev"
                className="pagination-previous">
                前へ
              </Link>
            )}
            {nextPagePath && (
              <Link to={nextPagePath} rel="next" className="pagination-next">
                次へ
              </Link>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination; */

import React from 'react';
import { Link } from 'gatsby';

/**
 * ページングの番号コンポーネント
 *
 * @param {Int, Int} { count, humanPageNumber }
 */
const PagerItem = ({ count, humanPageNumber }) => (
  <li
    key={`page${count}`}
    className={
      humanPageNumber === count ? 'pagination-link active' : 'pagination-link'
    }
    aria-label={`${count}ページ目`}
  >
    <Link to={count === 1 ? '/news/' : `/news/page/${count}`} rel="prev">
      {count}
    </Link>
  </li>
);

const Pagination = ({ pageContext }) => {
  const { previousPagePath, nextPagePath, numberOfPages, humanPageNumber } =
    pageContext;
  let count = 1;
  const pager = [];
  // Minimum Level(ページングの件数が10件以下の場合)
  if (numberOfPages < 10) {
    for (let i = 0; i < numberOfPages; i++) {
      pager.push(
        <PagerItem
          key={`page-${count}`}
          count={count}
          humanPageNumber={humanPageNumber}
        />
      );
      count++;
    }
  }

  // Low Level(ページングが10件以上あり、かつ選択したページが5ページ以下の場合)
  if (numberOfPages > 9 && humanPageNumber < 6) {
    for (let i = 0; i < 10; i++) {
      pager.push(
        <PagerItem
          key={`page-${count}`}
          count={count}
          humanPageNumber={humanPageNumber}
        />
      );
      count++;
    }
  }

  // Mid Level(選択したページが6ページ以降かつ、選択したページが総ページ数-8より少ない)
  if (humanPageNumber > 5 && humanPageNumber < numberOfPages - 8) {
    // eslint-disable-next-line no-shadow
    let count = humanPageNumber - 5;
    for (let i = 0; i < 10; i++) {
      pager.push(
        <PagerItem
          key={`page-${count}`}
          count={count}
          humanPageNumber={humanPageNumber}
        />
      );
      count++;
    }
  }

  // High Level(ページングが10件以上あり、選択したページが総ページ数-9より多い)
  if (numberOfPages > 9 && humanPageNumber > numberOfPages - 9) {
    // eslint-disable-next-line no-shadow
    let count = numberOfPages - 9;
    for (let i = 0; i < 10; i++) {
      pager.push(
        <PagerItem
          key={`page-${count}`}
          count={count}
          humanPageNumber={humanPageNumber}
        />
      );
      count++;
    }
  }

  return (
    <>
      {numberOfPages ? (
        <div className="pager">
          <nav
            className="pagination is-centered"
            role="navigation"
            aria-label="pagination"
          >
            {previousPagePath ? (
              <Link
                to={previousPagePath}
                rel="prev"
                className="pagination-previous"
              >
                <span>前へ</span>
              </Link>
            ) : (
              <div className="dummy pagination-previous" />
            )}
            <ul className="pagination-list">{pager}</ul>
            {nextPagePath ? (
              <Link to={nextPagePath} rel="next" className="pagination-next">
                <span>次へ</span>
              </Link>
            ) : (
              <div className="dummy pagination-next" />
            )}
          </nav>
        </div>
      ) : null}
    </>
  );
};

export default Pagination;
